import Vue from 'vue';
import Vuex from 'vuex';
import tramite from './modules/tramite';

import modal from '@/common/plugins/modal/mixins/modal';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    main: true,
    time: null,
    sessionInterval: null,
    toggle: true,
    auth: false,
    menu: {},
    user: {},
    date: {},
    permissions: {},
    rol: '',
    breadcrumbs: {},
    sidenav: false,
    maxFilesize: 0,
    alert: {
      show: false,
      text: '',
      callback: null
    },
    confirm: {
      show: false,
      text: '',
      callbackOk: null,
      callbackCancel: null,
      textOk: '',
      textCancel: ''
    },
    selected: null,
    modal: false,
    modal2: false,
    modal3: false,
    modal4: false,
    modal5: false,
    modal6: false,
    modal7: false,
    data: {},
    state403: false,
    touch: false,
    message: null,
    selectDate: null,
    changes: 0,
    archivo: 0,
    pin: null,
    loading: false,
    action: null
  },
  mutations: {
    toggleSidenav (state) {
      state.toggle = !state.toggle;
    },
    setToogle (state, value) {
      state.toggle = value;
    },
    openModal (state, id = '') {
      state[`modal${id}`] = true;
    },
    closeModal (state, id = '') {
      state[`modal${id}`] = false;
    },
    setSelectDate (state, value) {
      state.selectDate = value;
    },
    setMaxFilesize (state, value) {
      state.maxFilesize = value;
    },
    setDate (state, value) {
      if (state.date === undefined) {
        state.date = {};
      }
      if (value) {
        const keys = Object.keys(value);
        if (keys.length) {
          state.date[keys[0]] = value[keys[0]];
        } else {
          state.date = value;
        }
      } else {
        state.date = value;
      }
    },
    setTouch (state, value) {
      state.touch = value;
    },
    setSelected (state, value) {
      if (Array.isArray(value)) {
        state.selected = value;
      } else {
        if (!state.selected) {
          state.selected = [];
        }
        state.selected.push(value);
      }
    },
    setAction (state, value) {
      state.action = value;
    },
    setUser (state, value) {
      state.user = value;
    },
    setArchivo (state, value) {
      state.archivo = value;
    },
    setMenu (state, value) {
      state.menu = value;
    },
    setChanges (state, value) {
      state.changes = value;
    },
    setSidenav (state, value) {
      state.sidenav = value;
    },
    setAuth (state, value) {
      state.auth = value;
    },
    setPermissions (state, value) {
      state.permissions = value;
    },
    setMain (state, value) {
      state.main = value;
    },
    setPin (state, value) {
      state.pin = value;
    },
    setData (state, value) {
      state.data = value;
    },
    setLoading (state, value) {
      state.loading = value;
    },
    setDefault (state) {
      state.auth = false;
      state.menu = {};
      state.user = {};
      state.permissions = {};
      state.rol = '';
      state.breadcrumbs = {};
      state.modal = false;
      state.modal2 = false;
      state.modal3 = false;
      state.modal4 = false;
      state.modal5 = false;
      state.modal6 = false;
      state.modal7 = false;
      state.state403 = false;
      state.pin = null;
      state.loading = false;
      state.message = null;
      state.alert.show = false;
      state.confirm.show = false;
      state.selectDate = null;
      document.removeEventListener('keydown', modal.methods.bloquear, false);
    },
    CLOSE_ALERT (state) {
      state.alert.show = false;
      document.removeEventListener('keydown', modal.methods.bloquear, false);
    },
    CLOSE_CONFIRM (state) {
      state.confirm.show = false;
      document.removeEventListener('keydown', modal.methods.bloquear, false);
    },
    SET_TIME (state, value) {
      state.time = value;
    },
    TIME_DECREASE (state) {
      state.time--;
    }
  },
  modules: {
    tramite
  }
});

export default store;



// WEBPACK FOOTER //
// ./src/store/index.js